import { defineStore } from "pinia";
import { useSearchIdsStore } from "@/store/common/search_id_store";
import { TransactionType } from "@/interface/common/location_inteface";
import { useTransactionStore } from "@/store/common/transaction_type_store";
import { ConfigurationDetail } from "@/interface/common/terminal_configuration_interface";
import { TerminalConfigurationRepository } from "@/repository/terminal_configuration_repository";

export const useTerminalConfigurationStore = defineStore("useTerminalConfigurationStore", {
  state: (): {
    importConfiguration: ConfigurationDetail;
    exportConfiguration: ConfigurationDetail;
    equipmentConfiguration: ConfigurationDetail;
    scheduleConfiguration: ConfigurationDetail;
    searchIdLimit: number;
    transationType: TransactionType[];
    showContainer: boolean;
    isLoading: boolean;
    error: string | null;
  } => ({
    importConfiguration: {} as ConfigurationDetail,
    exportConfiguration: {} as ConfigurationDetail,
    equipmentConfiguration: {} as ConfigurationDetail,
    scheduleConfiguration: {} as ConfigurationDetail,
    searchIdLimit: 50,
    transationType: [] as TransactionType[],
    showContainer: false,
    isLoading: false,
    error: null
  }),
  persist: false,
  getters: {},
  actions: {
    async fetchConfiguration(id: string): Promise<void> {
      this.isLoading = true;
      this.error = null;
      try {
        // Checking for bg color for vessel status
        const transactionState = useTransactionStore();
        const repository = new TerminalConfigurationRepository();
        const configuration = await repository.getTerminalConfiguration(id.toLocaleLowerCase());
        this.importConfiguration = configuration.import;
        this.exportConfiguration = configuration.export;
        this.equipmentConfiguration = configuration.equipment;
        this.scheduleConfiguration = configuration.schedule;
        transactionState.updateTransactionData(configuration.transactionType);
        this.setSearchIdLimit();
      } catch (e: any) {
        this.isLoading = false;
        this.error = e.message || "Unknown error occurred";
      }
    },

    setSearchIdLimit(): any {
      const searchIdsStore = useSearchIdsStore();
      if (searchIdsStore.transactionType === "PUI") {
        this.searchIdLimit = this.importConfiguration.searchIdLimit ?? 50;
      } else if (searchIdsStore.transactionType === "DOE") {
        this.searchIdLimit = this.exportConfiguration.searchIdLimit ?? 50;
      } else if (searchIdsStore.transactionType === "CEH") {
        this.searchIdLimit = this.equipmentConfiguration.searchIdLimit ?? 10;
      } else {
        this.searchIdLimit = 10;
      }
    },

    // Toggle the container to show or hide
    toggleContainer(): void {
      this.showContainer = !this.showContainer;
    }
  }
});
